<template lang="html">
  <div>
    <section>
      <v-parallax
        class="si-hero-parallax"
        dark
        :height="200"
        :src="require('@/assets/background_2.svg')"
      >
        <v-container
          grid-list-lg
          fill-height
          fluid
          :style="`background-color: rgb(0 0 0 / 20%); background:linear-gradient(to ${
            $vuetify.breakpoint.xsOnly ? 'top' : 'right'
          }, rgb(0 0 0 / 50%) 30%, rgb(0 0 0 / 0%)`"
        >
          <v-layout
            justify-center
            align-center
            fill-height
          >
            <v-flex
              xs12
              md10
              lg8
              xl7
              mx-auto
            >
              <v-layout
                wrap
                align-center
              >
                <v-flex
                  xs12
                  class="white--text "
                >
                  <div class="text-h3 text-sm-h2 font-weight-light text-center text-md-left">
                    The Bulletin
                  </div>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-parallax>
    </section>

    <v-container
      grid-list-sm
      my-8
      fluid
    >
      <v-layout wrap>
        <v-flex v-bind="_pageLayout">
          <v-form ref="form">
            <v-layout wrap>
              <v-flex
                xs12
                md5
                mb-4
                pr-6
                class=""
              >
                <div class="text-h6 pb-4">
                  Register for The Bulletin.
                </div>
                <div>
                  The Bulletin (ISSN 2653-3928) is a limited distribution magazine published by Super Info in June and December each year. It provides useful and relevant information for professionals working in family law, financial services and the superannuation industry.
                </div>
              </v-flex>
              <v-flex
                xs12
                md7
              >
                <v-expand-transition>
                  <v-flex
                    v-if="submitted"
                    xs12
                    pa-0
                  >
                    <v-alert
                      color="info"
                      outlined
                    >
                      <div class="title">
                        Thank you
                      </div>
                      <div class="">
                        Thank you for registering for The Bulletin. You have been added to our distribution list.
                      </div>
                      <v-btn
                        depressed
                        color="info"
                        class="mt-4"
                        to="/"
                      >
                        Take me home
                      </v-btn>
                    </v-alert>
                  </v-flex>
                </v-expand-transition>

                <v-expand-transition>
                  <v-layout
                    v-if="!submitted"
                    wrap
                  >
                    <v-flex xs6>
                      <SiInputText
                        v-model="subscribe.firstName"
                        label="First Name"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex xs6>
                      <SiInputText
                        v-model="subscribe.lastName"
                        label="Last Name"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex xs12>
                      <SiInputText
                        v-model="subscribe.company"
                        label="Business / Company name"
                        filled
                      />
                    </v-flex>
                    <v-flex class="text-subtitle">
                      Contact
                    </v-flex>
                    <v-flex xs12>
                      <SiInputText
                        v-model="subscribe.email"
                        label="Email"
                        required
                        filled
                        :rules="[_ruleEmail()]"
                      />
                    </v-flex>
                    <v-flex xs12>
                      <SiInputText
                        v-model="subscribe.phone"
                        label="Phone"
                        filled
                      />
                    </v-flex>
                    <v-flex class="text-subtitle">
                      Address
                    </v-flex>
                    <v-flex xs12>
                      <SiInputText
                        v-model="subscribe.address1"
                        label="Address line 1"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex xs12>
                      <SiInputText
                        v-model="subscribe.address2"
                        label="Address line 2"
                        filled
                      />
                    </v-flex>
                    <v-flex xs12>
                      <SiInputText
                        v-model="subscribe.city"
                        label="City"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm7
                    >
                      <SiInputSelect
                        v-model="subscribe.province"
                        name="province"
                        :items="[
                          'Australian Capital Territory',
                          'New South Wales',
                          'Northern Territory',
                          'Queensland',
                          'South Australia ',
                          'Tasmania',
                          'Victoria',
                          'Western Australia'
                        ]"
                        label="State / Territory"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      sm5
                    >
                      <SiInputText
                        v-model="subscribe.postcode"
                        label="Postcode"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex xs12>
                      <SiInputSelect
                        v-model="subscribe.source"
                        :items="[
                          'The Bulletin',
                          'Super Info website',
                          'Search engine',
                          'Word of mouth',
                          'Other' 
                        ]"
                        label="How did you hear about The Bulletin"
                        required
                        filled
                      />
                    </v-flex>
                    <v-flex
                      xs12
                      text-right
                    >
                      <v-btn
                        color="primary"
                        :loading="loading"
                        large
                        @click="submitSubscribe"
                      >
                        Register
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-expand-transition>
              </v-flex>
              <!-- </v-expand-transition> -->
            </v-layout>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { rtdb } from '@/plugins/firebase'
import validations from '@/mixins/validations'
import clientPath from '@/plugins/client-path'
import moment from 'moment'

export default {
  mixins: [ validations ],
  data () {
    return {
      submitted: false,
      loading: false,
      subscribe: {}
    }
  },
  computed: {
    ...mapGetters(['_pageLayout'])
  },
  mounted () {
    clientPath.track(`open_subscribe`)
  },
  methods: {
    submitSubscribe () {
      if (!this.$refs.form.validate()) return
      this.loading = true
      rtdb.ref('webForms/bulletin').push(Object.assign(this.subscribe, { timestamp: new Date().toISOString(), time: moment().format('HH:mm DD-MMM-YYYY') }))
        .then(() => {
          this.submitted = true
          this.loading = false
        })
      clientPath.identify(this.subscribe.email, `${this.subscribe.firstName} ${this.subscribe.lastName}`)
      clientPath.track(`submit_subscribe`)

    }
  }
}
</script>

<style lang="css" scoped>

</style>
